(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mt-visible');
            observador.unobserve(e.target);
            if (e.target.dataset.mtCount) contar(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  function contar(el) {
    var objetivo = parseFloat(el.dataset.mtCount);
    var dec = (el.dataset.mtCount.split('.')[1] || '').length;
    var num = el.querySelector('[data-mt-num]');
    if (!num || isNaN(objetivo)) return;
    if (reducido) { num.textContent = objetivo.toFixed(dec); return; }
    var inicio = null, dur = 1400;
    function paso(t) {
      if (!inicio) inicio = t;
      var p = Math.min((t - inicio) / dur, 1);
      var v = objetivo * (1 - Math.pow(1 - p, 3));
      num.textContent = v.toFixed(dec);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  function initHero(raiz) {
    (raiz || document).querySelectorAll('[data-mt-hero]').forEach(function (hero) {
      if (hero.dataset.mtInit) return;
      hero.dataset.mtInit = '1';
      var img = hero.querySelector('.mt-hero-media img');
      var arrancar = function () { requestAnimationFrame(function () { hero.classList.add('mt-cargado'); }); };
      if (!img || img.complete) arrancar(); else { img.addEventListener('load', arrancar); setTimeout(arrancar, 1500); }
      if (reducido || window.matchMedia('(hover: none)').matches) return;
      hero.addEventListener('mousemove', function (ev) {
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--mt-fx', ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        hero.style.setProperty('--mt-fy', ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
  }

  function initHotspots(raiz) {
    (raiz || document).querySelectorAll('[data-mt-hotspots]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var puntos = sec.querySelectorAll('.mt-hs-punto');
      var tarjetas = sec.querySelectorAll('.mt-hs-tarjeta');
      var items = sec.querySelectorAll('.mt-hs-lista li');
      function abrir(i) {
        puntos.forEach(function (p, k) { p.setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
        tarjetas.forEach(function (t, k) { t.classList.toggle('mt-abierta', k === i); });
        items.forEach(function (t, k) { t.classList.toggle('mt-activo', k === i); });
      }
      puntos.forEach(function (p, i) {
        p.addEventListener('mouseenter', function () { abrir(i); });
        p.addEventListener('focus', function () { abrir(i); });
        p.addEventListener('click', function () {
          abrir(i);
          if (items[i] && window.matchMedia('(max-width: 749px)').matches) items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });
      sec.querySelector('.mt-hs-escena').addEventListener('mouseleave', function () { abrir(-1); });
    });
  }

  function initFaq(raiz) {
    (raiz || document).querySelectorAll('.mt-faq-item').forEach(function (it) {
      if (it.dataset.mtInit) return;
      it.dataset.mtInit = '1';
      var btn = it.querySelector('.mt-faq-btn');
      btn.addEventListener('click', function () {
        var abierta = it.classList.toggle('mt-abierta');
        btn.setAttribute('aria-expanded', abierta ? 'true' : 'false');
      });
    });
  }

  var capitulos = [];
  function initCapitulos(raiz) {
    (raiz || document).querySelectorAll('[data-mt-capitulos]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      capitulos.push(sec);
    });
    medirCapitulos();
  }
  function medirCapitulos() {
    capitulos.forEach(function (sec) {
      var alta = sec.querySelector('.mt-cap-pista-alta');
      var tira = sec.querySelector('.mt-cap-tira');
      if (!alta || !tira) return;
      if (reducido || window.innerWidth < 990) { alta.style.height = ''; tira.style.transform = ''; return; }
      var extra = Math.max(tira.scrollWidth - window.innerWidth, 0);
      sec._mtExtra = extra;
      alta.style.height = (window.innerHeight + extra) + 'px';
    });
    moverCapitulos();
  }
  function moverCapitulos() {
    capitulos.forEach(function (sec) {
      if (reducido || window.innerWidth < 990) return;
      var alta = sec.querySelector('.mt-cap-pista-alta');
      var tira = sec.querySelector('.mt-cap-tira');
      var r = alta.getBoundingClientRect();
      var total = alta.offsetHeight - window.innerHeight;
      var p = total > 0 ? Math.min(Math.max(-r.top / total, 0), 1) : 0;
      tira.style.transform = 'translate3d(' + (-p * (sec._mtExtra || 0)) + 'px,0,0)';
      sec.style.setProperty('--mt-prog', p.toFixed(3));
    });
  }

  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-mt-producto]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var principal = sec.querySelector('.mt-pp-principal img');
      var minis = sec.querySelectorAll('.mt-pp-mini');
      function verFoto(src, idMedia) {
        if (!principal || !src) return;
        principal.style.opacity = 0;
        setTimeout(function () { principal.src = src; principal.removeAttribute('srcset'); principal.style.opacity = 1; }, 150);
        minis.forEach(function (m) { m.classList.toggle('mt-activo', m.dataset.mediaId === String(idMedia)); });
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () { verFoto(m.dataset.src, m.dataset.mediaId); });
      });

      var cant = sec.querySelector('.mt-pp-cantidad input');
      sec.querySelectorAll('.mt-pp-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          cant.value = Math.max(1, v + (b.dataset.paso === '+' ? 1 : -1));
        });
      });

      var datos = sec.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var inputId = sec.querySelector('input[name="id"]');
      var precio = sec.querySelector('[data-mt-precio]');
      var tachado = sec.querySelector('[data-mt-tachado]');
      var boton = sec.querySelector('[data-mt-boton]');
      var aviso = sec.querySelector('.mt-pp-agotado');
      var textoBoton = boton ? boton.dataset.texto : '';
      var textoAgotado = boton ? boton.dataset.agotado : '';
      function actualizar() {
        var elegidas = [];
        sec.querySelectorAll('.mt-pp-opcion fieldset').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          elegidas.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        if (!v) {
          if (boton) { boton.disabled = true; boton.textContent = textoAgotado; }
          if (aviso) aviso.textContent = sec.dataset.textoNoDisponible || '';
          return;
        }
        inputId.value = v.id;
        if (precio) precio.textContent = v.precio;
        if (tachado) { tachado.textContent = v.tachado || ''; tachado.hidden = !v.tachado; }
        if (boton) { boton.disabled = !v.available; boton.textContent = v.available ? textoBoton : textoAgotado; }
        if (aviso) aviso.textContent = '';
        if (v.foto) verFoto(v.foto, v.mediaId);
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      sec.querySelectorAll('.mt-pp-opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });
    });
  }

  function initTodo(ev) {
    var raiz = ev && ev.target && ev.target.nodeType === 1 ? ev.target : document;
    initReveals(raiz);
    initHero(raiz);
    initHotspots(raiz);
    initFaq(raiz);
    initCapitulos(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
  window.addEventListener('scroll', function () { requestAnimationFrame(moverCapitulos); }, { passive: true });
  window.addEventListener('resize', function () { requestAnimationFrame(medirCapitulos); });
  window.addEventListener('load', medirCapitulos);
})();
